import { render, staticRenderFns } from "./m-card.vue?vue&type=template&id=08808637&scoped=true&v-if=href"
import script from "./m-card.vue?vue&type=script&lang=js"
export * from "./m-card.vue?vue&type=script&lang=js"
import style0 from "./m-card.vue?vue&type=style&index=0&id=08808637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08808637",
  null
  
)

export default component.exports